
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

const useProblema = () => {

    // variables
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [tieneProblemas, setTieneProblemas] = useState( false )
    const problemasInicial = {
        funcion: 'guardarProblemas',
        tipo: '',
        problema: '',
        correo: objLogueado.email
    }
    const { URL } = url()
    const [problemasActuales, setProblemasActuales] = useState([])
    const [formProblemas, setFormProblemas] = useState( problemasInicial )
    const [pkProblemaActual, setPkProblemaActual] = useState( 0 )
    const [isOpen, setIsOpen] = useState( false )
    const [cargando, setCargando] = useState( false )



    // funciones
    const traerProblemas = () => {

        var fd = new FormData()
        fd.append("funcion", "traerProblemas")
        fd.append("correo", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setProblemasActuales( e )
            if ( e.length > 0 ) {
                setTieneProblemas( true )
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la información de tus problemas auditivos/ortopédicos', 'error' )
        })
    }


    const guardarProblemas = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formProblemas, pkProblemaActual })
        })
        .then( res => res.json() )
        .then( function (d) {
            traerProblemas()
            if ( d.codigo === 1 && pkProblemaActual === 0 ) {
                elToast( d.mensaje )
                setFormProblemas( problemasInicial )
            } else if ( d.codigo === 0 ) {
                elToast( d.mensaje, 'error' )
            } else if ( d.codigo === 1 ) {
                elToast( d.mensaje )
                setFormProblemas( problemasInicial )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
        })
        .finally( () => setCargando( false ) )
    }

    const editarProblemas = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formProblemas, pk_problema: pkProblemaActual, funcion: 'editarProblemas' })
        })
        .then( res => res.json() )
        .then( function (d) {
            traerProblemas()
            if ( d.codigo === 1 ) {
                // si se guardó
                elToast( d.mensaje )
                setFormProblemas( problemasInicial )
                cerrarModal()
            } else if ( d.codigo === 0 ) {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
        })
        .finally( () => setCargando( false ) )
    }


    function borrarProblemas( pk_problema ) {
        if ( pk_problema && window.confirm("El registro será eliminado.") ) {
            fetch( URL, {
                method: 'post',
                body: JSON.stringify({ pk_problema: pk_problema, funcion: 'borrarProblemas' })
            })
            .then( res => res.json() )
            .then( function (d) {
                if ( d.codigo === 1 ) {
                    traerProblemas()
                    elToast( 'Eliminado con éxito' )
                } else {
                    elToast( d.mensaje, 'info' )
                }
            })
            .catch( a => {
                elToast( "Error al eliminar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
            })
        }
    }

    const abrirModal = () => {
        setIsOpen( true )
    }

    const cerrarModal = () => {
        setIsOpen( false )
        setFormProblemas( problemasInicial )
    }

    function llenarFormProblemas( e ) {
        setFormProblemas({
            funcion: 'editarProblemas',
            tipo: e.tipo,
            problema: e.problema,
            correo: objLogueado.email
        })
        setPkProblemaActual( e.pk_problema )
        abrirModal()
    }


    // useEffects
    useEffect(() => {
        traerProblemas()
        // eslint-disable-next-line
    }, [])


    return {
        problemasActuales, tieneProblemas, setTieneProblemas,
        cargando, guardarProblemas,
        formProblemas, setFormProblemas,
        llenarFormProblemas, isOpen, cerrarModal,
        editarProblemas, borrarProblemas
    }
}

export default useProblema
